import { useMPEFetch } from '@retail/app/hooks';
import { useMgPrisConfig } from '@retail/app/stores/app-config';
import { useAuthContext } from '@retail/auth/data-access';
import { mpeApi } from '@retail/mgpris/config';
import { QueryOptions } from '@shared/fetch-utils';
import { HierarchyFilterContextDTO } from '@retail/my-assortment/types';
import { buildUrl } from '@shared/utils';

interface SearchProps {
  assortmentId: number;
  supplierNumber?: number;
}

export function useFetchPriceSuggestionFilterContext(
  { assortmentId, supplierNumber }: SearchProps,
  queryOptions: QueryOptions = {}
) {
  const { mpe } = useMgPrisConfig();
  const { token } = useAuthContext();

  return useMPEFetch<HierarchyFilterContextDTO>({
    method: 'GET',
    queryKey: ['price-suggestion-filter-context', assortmentId, supplierNumber],
    token,
    url: buildUrl({
      base: mpe.url,
      route: mpeApi.priceSuggestion.filterContext.getFullLinkPath(),
      searchParams: { assortmentId, supplierNumber },
    }),
    ...queryOptions,
  });
}
